import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-package-summary-dialog.controller';
import template from './edit-package-summary-dialog.html';

class dialogService {
  getOptions($event, { reportPackage }) {
    return {
      controller,
      controllerAs: 'editPackageSummaryDialogVM',
      locals: {
        reportPackage,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.editPackageSummaryDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
  ])
  .service('editPackageSummaryDialog', dialogService).name;
